import React from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import Badge from 'react-bootstrap/Badge';
import IssueRequest from "../../magData/Flight/IssueRequest";
import ReserveResponse from "../../magData/Flight/ReserveResponse";

function FlightTicketPage() {

    return (
        <>

            <Container fluid >
                <Row>
                    <Col sm={12} >
                        <p className="page-title">Flight Ticket Method</p>
                    </Col>
                    <Col sm={12} >
                        <p>EndPoint : https://gdscpapi.parsgds.com/gateway/flight/ticket</p>
                    </Col>
                    <Col sm={12} >
                        <p> type : json (default)</p>
                    </Col>
                </Row>
                <Row>
                    <Col sm={12} >
                        <p>Body Parameters</p>
                    </Col>
                    <Col sm={12} >

                        <Table striped bordered>
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Description</th>
                                    <th>Type</th>
                                    <th>Additional information</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>gdsRefrenceID</td>
                                    <td>Refrence ID</td>
                                    <td>Guid </td>
                                    <td><Badge bg="warning" text="dark">
                                        Required
                                    </Badge></td>
                                </tr>

                            </tbody>
                        </Table>
                    </Col>

                </Row>
                <Row>
                    <Col sm={12}><span className="code-section-title">Request Formats - application/json, text/json</span></Col>
                    <Col sm={12}>

                        <pre className="code-section">
                            {JSON.stringify(IssueRequest, null, 2)}
                        </pre>


                    </Col>
                </Row>

                {/* Response  */}
                <Row>
                    <Col sm={12} >
                        <p>Response Information</p>
                    </Col>
                    <Col sm={12} >

                        <Table striped bordered>
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Description</th>
                                    <th>Type</th>
                                    <th>Additional information</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>gdsRefrenceID</td>
                                    <td>Refrence ID</td>
                                    <td>Guid </td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>fareType</td>
                                    <td>fare Type</td>
                                    <td>integer</td>
                                    <td> <p>Default - 1 - Default</p>
                                        <p>Publish - 2 - Publish</p>
                                        <p>Private - 3 - Private</p>
                                        <p>WebFare - 4 - Instant Purchase, doesn't allow to reserve and will issue by calling Airbook</p> </td>
                                </tr>
                                <tr>
                                    <td>bookedBy</td>
                                    <td> User who booked the flight</td>
                                    <td>string </td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>orderBy</td>
                                    <td>User who ordered the booking</td>
                                    <td>string </td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>clientBalance</td>
                                    <td>Balance of your account</td>
                                    <td>decimal</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>tktTimeLimit</td>
                                    <td>Ticket Time Limit</td>
                                    <td>date </td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>refundMethod</td>
                                    <td>Refund Method</td>
                                    <td>integer </td>
                                    <td><p>0 : Offline </p>
                                        <p>1 : Online</p>
                                        <p>2 : NonRefundable</p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>validatingAirlineCode</td>
                                    <td>Airline Code</td>
                                    <td>String </td>
                                    <td> </td>
                                </tr>
                                <tr>
                                    <td>travelItinerary</td>
                                    <td>Flight Itinerary</td>
                                    <td>Object </td>
                                    <td></td>
                                </tr>
                                <tr >
                                    <td colSpan={4}> <Table bordered>
                                        <tbody>
                                            <tr>
                                                <td>itineraryInfo</td>
                                                <td>Itinerary Info</td>
                                                <td>Object </td>
                                                <td></td>
                                            </tr>
                                            <tr >
                                                <td colSpan={4}> <Table bordered>
                                                    <tbody>
                                                        <tr>
                                                            <td>itineraryPricing</td>
                                                            <td>Itinerary Pricing</td>
                                                            <td>Object </td>
                                                            <td></td>
                                                        </tr>
                                                        <tr >
                                                            <td colSpan={4}> <Table bordered>
                                                                <tbody>
                                                                    <tr>
                                                                        <td>baseFare</td>
                                                                        <td>Base Fare</td>
                                                                        <td>decimal  </td>
                                                                        <td></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>serviceTax</td>
                                                                        <td>Service Tax</td>
                                                                        <td>decimal  </td>
                                                                        <td></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>totalTax</td>
                                                                        <td>Total Tax</td>
                                                                        <td>decimal  </td>
                                                                        <td></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>totalFare</td>
                                                                        <td>Total Fare</td>
                                                                        <td>decimal  </td>
                                                                        <td></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>currency</td>
                                                                        <td>Currency</td>
                                                                        <td>string </td>
                                                                        <td></td>
                                                                    </tr>
                                                                </tbody>
                                                            </Table>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>customerInfoes</td>
                                                            <td> Customer Information</td>
                                                            <td>Collection  </td>
                                                            <td></td>
                                                        </tr>
                                                        <tr >
                                                            <td colSpan={4}> <Table bordered>
                                                                <tbody>
                                                                    <tr>
                                                                        <td>customer</td>
                                                                        <td>Passenger information</td>
                                                                        <td>Object</td>
                                                                        <td></td>
                                                                    </tr>
                                                                    <tr >
                                                                        <td colSpan={4}> <Table bordered>
                                                                            <tbody>
                                                                                <tr>
                                                                                    <td>gender</td>
                                                                                    <td>Gender</td>
                                                                                    <td>integer</td>
                                                                                    <td><p>1 : Male</p><p>2 : Female</p></td>
                                                                                </tr>

                                                                                <tr>
                                                                                    <td>passengerType</td>
                                                                                    <td>Passenger Type</td>
                                                                                    <td>integer </td>
                                                                                    <td><p>1 : Adult</p><p>2 : Child</p><p>3 : Infant</p></td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td>passportNumber</td>
                                                                                    <td>Passport Number</td>
                                                                                    <td>string </td>
                                                                                    <td></td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td>nationalId</td>
                                                                                    <td>National Id</td>
                                                                                    <td>string </td>
                                                                                    <td></td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td>nationality</td>
                                                                                    <td>Country Code</td>
                                                                                    <td>string </td>
                                                                                    <td></td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td>dateOfBirth</td>
                                                                                    <td>Date of Birth</td>
                                                                                    <td>date </td>
                                                                                    <td></td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td>passportExpireDate</td>
                                                                                    <td>Passport Expire Date</td>
                                                                                    <td>date </td>
                                                                                    <td></td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td>passportIssueCountry</td>
                                                                                    <td>Country Code</td>
                                                                                    <td>string </td>
                                                                                    <td></td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td>passportIssueDate</td>
                                                                                    <td>Passport Issue Date</td>
                                                                                    <td>date </td>
                                                                                    <td></td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td>paxName</td>
                                                                                    <td>Passenger Name</td>
                                                                                    <td>Object </td>
                                                                                    <td></td>
                                                                                </tr>
                                                                                <tr >
                                                                                    <td colSpan={4}> <Table bordered>
                                                                                        <tbody>
                                                                                            <tr>
                                                                                                <td>passengerFirstName</td>
                                                                                                <td>Passenger First name</td>
                                                                                                <td>integer </td>
                                                                                                <td></td>
                                                                                            </tr>
                                                                                            <tr>
                                                                                                <td>passengerMiddleName</td>
                                                                                                <td>Passenger middle name</td>
                                                                                                <td>integer </td>
                                                                                                <td></td>
                                                                                            </tr>
                                                                                            <tr>
                                                                                                <td>passengerLastName</td>
                                                                                                <td>Passenger last name</td>
                                                                                                <td>integer </td>
                                                                                                <td></td>
                                                                                            </tr>
                                                                                            <tr>
                                                                                                <td>passengerTitle</td>
                                                                                                <td>Passenger Title</td>
                                                                                                <td>integer </td>
                                                                                                <td><p>0 : Mr</p><p>1 : Mrs</p>
                                                                                                    <p>2 : Ms</p><p>3 : Miss</p><p>4 : Mstr</p></td>
                                                                                            </tr>
                                                                                        </tbody>
                                                                                    </Table>
                                                                                    </td>

                                                                                </tr>
                                                                            </tbody>
                                                                        </Table>
                                                                        </td>

                                                                    </tr>
                                                                    <tr>
                                                                        <td>eTickets</td>
                                                                        <td>E-Ticket Number</td>
                                                                        <td>string </td>
                                                                        <td></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>eTicketNumbers</td>
                                                                        <td>E-Ticket Number Info</td>
                                                                        <td>Collection  </td>
                                                                        <td></td>
                                                                    </tr>
                                                                    <tr >
                                                                        <td colSpan={4}> <Table bordered>
                                                                            <tbody>
                                                                                <tr>
                                                                                    <td>eTicketNumber</td>
                                                                                    <td>E-Ticket Number</td>
                                                                                    <td>integer </td>
                                                                                    <td></td>
                                                                                </tr>

                                                                                <tr>
                                                                                    <td>eticketStatus</td>
                                                                                    <td>E-Ticket Status</td>
                                                                                    <td>integer </td>
                                                                                    <td>
                                                                                        <p>1 : Ticket</p>
                                                                                        <p>2 : Refund</p>
                                                                                        <p>3 : Void </p>
                                                                                        <p>4 : Unknown </p>
                                                                                    </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td>isRefunded</td>
                                                                                    <td>Is Refunded</td>
                                                                                    <td>boolean </td>
                                                                                    <td></td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td>dateOfIssue</td>
                                                                                    <td>Date Of Issue</td>
                                                                                    <td>date </td>
                                                                                    <td></td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td>airlinePnr</td>
                                                                                    <td>Airline PNR</td>
                                                                                    <td>string </td>
                                                                                    <td></td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td>totalRefund</td>
                                                                                    <td>Total Refund</td>
                                                                                    <td>decimal  </td>
                                                                                    <td></td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </Table>
                                                                        </td>

                                                                    </tr>
                                                                </tbody>
                                                            </Table>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>reservationItems</td>
                                                            <td>Reservation Details</td>
                                                            <td>Collection </td>
                                                            <td></td>
                                                        </tr>
                                                        <tr >
                                                            <td colSpan={4}> <Table bordered>
                                                                <tbody>
                                                                    <tr>
                                                                        <td>airEquipmentType</td>
                                                                        <td>Air Equipment Type</td>
                                                                        <td>string </td>
                                                                        <td></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>airlinePnr</td>
                                                                        <td>Airline PNR</td>
                                                                        <td>string </td>
                                                                        <td></td>
                                                                    </tr>

                                                                    <tr>
                                                                        <td>arrivalAirportLocationCode</td>
                                                                        <td>Arrival Airport Code</td>
                                                                        <td>string </td>
                                                                        <td></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>arrivalDateTime</td>
                                                                        <td>Arrival Date and Time</td>
                                                                        <td>date </td>
                                                                        <td></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>arrivalTerminal</td>
                                                                        <td>Arrival Terminal</td>
                                                                        <td>string </td>
                                                                        <td></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>baggage</td>
                                                                        <td>Baggage information</td>
                                                                        <td>array Of string </td>
                                                                        <td></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>departureAirportLocationCode</td>
                                                                        <td>Departure Airport Code</td>
                                                                        <td>string </td>
                                                                        <td></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>departureDateTime</td>
                                                                        <td>Departure Date and Time</td>
                                                                        <td>date </td>
                                                                        <td></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>departureTerminal</td>
                                                                        <td>Departure Terminal</td>
                                                                        <td>string </td>
                                                                        <td></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>flightNumber</td>
                                                                        <td>Flight Number</td>
                                                                        <td>string </td>
                                                                        <td></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>journeyDuration</td>
                                                                        <td>Journey Duration</td>
                                                                        <td>string </td>
                                                                        <td></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>journeyDurationPerMinute</td>
                                                                        <td>Journey Duration Per Minute</td>
                                                                        <td>integer </td>
                                                                        <td></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>marketingAirlineCode</td>
                                                                        <td>Marketing Carrier</td>
                                                                        <td>string </td>
                                                                        <td></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>operatingAirlineCode</td>
                                                                        <td>Operating Carrier</td>
                                                                        <td>string </td>
                                                                        <td></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>resBookDesigCode</td>
                                                                        <td>Reservation Booking Designator Code</td>
                                                                        <td>string </td>
                                                                        <td></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>stopQuantity</td>
                                                                        <td>Number of stop per segment</td>
                                                                        <td>integer </td>
                                                                        <td></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>isCharter</td>
                                                                        <td>flight is Charter</td>
                                                                        <td>boolean </td>
                                                                        <td></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>isReturn</td>
                                                                        <td>return Segment</td>
                                                                        <td>boolean </td>
                                                                        <td></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>cabinClassCode</td>
                                                                        <td>Cabin Class Code</td>
                                                                        <td>string</td>
                                                                        <td>Y - S - C - J - F - P </td>
                                                                    </tr>

                                                                    <tr>
                                                                        <td>technicalStops</td>
                                                                        <td>Technical Stop</td>
                                                                        <td>integer </td>
                                                                        <td></td>
                                                                    </tr>
                                                                    <tr >
                                                                        <td colSpan={4}> <Table bordered>
                                                                            <tbody>
                                                                                <tr>
                                                                                    <td>arrivalAirport</td>
                                                                                    <td>Arrival Airport Code</td>
                                                                                    <td>string </td>
                                                                                    <td></td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td>arrivalDateTime</td>
                                                                                    <td>Arrival Date and Time</td>
                                                                                    <td>date </td>
                                                                                    <td></td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td>departureDateTime</td>
                                                                                    <td>Departure Date and Time</td>
                                                                                    <td>date </td>
                                                                                    <td></td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </Table>
                                                                        </td>

                                                                    </tr>

                                                                </tbody>
                                                            </Table>
                                                            </td>

                                                        </tr>
                                                        <tr>
                                                            <td>tripDetailPtcFareBreakdowns</td>
                                                            <td>Trip Details and Fare Break Down Per Passenger Type</td>
                                                            <td>Collection  </td>
                                                            <td></td>
                                                        </tr>
                                                        <tr >
                                                            <td colSpan={4}> <Table bordered>
                                                                <tbody>
                                                                    <tr>
                                                                        <td>passengerTypeQuantity</td>
                                                                        <td>Passenger Type Quantity</td>
                                                                        <td>object </td>
                                                                        <td></td>
                                                                    </tr>
                                                                    <tr >
                                                                        <td colSpan={4}> <Table bordered>
                                                                            <tbody>
                                                                                <tr>
                                                                                    <td>passengerType</td>
                                                                                    <td>Passenger Type</td>
                                                                                    <td>integer </td>
                                                                                    <td>
                                                                                        <p>1=Adult</p>
                                                                                        <p>2=Child</p>
                                                                                        <p>3=Infant</p>
                                                                                    </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td>quantity</td>
                                                                                    <td>Quantity</td>
                                                                                    <td>integer </td>
                                                                                    <td></td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </Table>
                                                                        </td>

                                                                    </tr>
                                                                </tbody>
                                                            </Table>
                                                            </td>

                                                        </tr>

                                                        <tr >
                                                            <td colSpan={4}> <Table bordered>
                                                                <tbody>
                                                                    <tr>
                                                                        <td>tripDetailPassengerFare</td>
                                                                        <td>Trip Detail Passenger Fare</td>
                                                                        <td>object</td>
                                                                        <td></td>
                                                                    </tr>
                                                                    <tr >
                                                                        <td colSpan={4}> <Table bordered>
                                                                            <tbody>
                                                                                <tr>
                                                                                    <td>baseFare</td>
                                                                                    <td>Base Fare</td>
                                                                                    <td>double </td>
                                                                                    <td></td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td>serviceTax</td>
                                                                                    <td>Service Tax</td>
                                                                                    <td>double </td>
                                                                                    <td></td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td>tax</td>
                                                                                    <td>Tax</td>
                                                                                    <td>double </td>
                                                                                    <td></td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td>totalFare</td>
                                                                                    <td>Total Fare</td>
                                                                                    <td>double </td>
                                                                                    <td></td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td>commission</td>
                                                                                    <td>Commission </td>
                                                                                    <td>double </td>
                                                                                    <td></td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td>currency</td>
                                                                                    <td>Currency</td>
                                                                                    <td>string </td>
                                                                                    <td></td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </Table>
                                                                        </td>

                                                                    </tr>
                                                                </tbody>
                                                            </Table>
                                                            </td>

                                                        </tr>
                                                        <tr>
                                                            <td>phoneNumber</td>
                                                            <td>PhoneNumber</td>
                                                            <td>string </td>
                                                            <td></td>
                                                        </tr>
                                                        <tr>
                                                            <td>email</td>
                                                            <td>Email Address</td>
                                                            <td>string </td>
                                                            <td></td>
                                                        </tr>
                                                    </tbody>
                                                </Table>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                    </td>
                                </tr>
                                <tr>
                                    <td>directionInd</td>
                                    <td>Cabin Type</td>
                                    <td>integer </td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </Table>
                    </Col>

                </Row>
                <Row>
                    <Col sm={12}><span className="code-section-title">Response Formats - application/json, text/json</span></Col>
                    <Col sm={12}>

                        <pre className="code-section">
                            {JSON.stringify(ReserveResponse, null, 2)}
                        </pre>


                    </Col>
                </Row>
            </Container>

        </>
    );
}

export default FlightTicketPage;